import { CORNIS, SKYSPECS, SKYSPECS_ORG } from 'utils/constants';

/**
 * Two concepts live here:
 *
 * **Classification** (`isSkySpecsInspection` / `isCornisInspection`) is deliberately NOT gated
 * behind `INSPECTION_VENDOR_NAMES` so that behavior is consistent between users with and without inspection_vendor_names toggle.
 *
 * **Display** (`getInspectionVendorDisplayName`) IS gated, via a required `hasVendorNames`
 * argument.
 */

type InspectionVendorFields = {
  vendor?: { name?: string | null } | null;
  vendorOrganization?: { id: string; name?: string | null } | null;
};

export function getInspectionVendorDisplayName(
  inspection: InspectionVendorFields | null | undefined,
  hasVendorNames: boolean
): string | null | undefined {
  // Without the toggle, the legacy `vendor` name is shown exactly as stored for BE sort/filter consistency
  if (!hasVendorNames) {
    return inspection?.vendor?.name;
  }

  return inspection?.vendorOrganization?.name ?? inspection?.vendor?.name;
}

export function isSkySpecsInspection(inspection?: InspectionVendorFields | null): boolean {
  if (inspection?.vendorOrganization) {
    return inspection.vendorOrganization.id === SKYSPECS_ORG;
  }

  return inspection?.vendor?.name?.toLowerCase() === SKYSPECS;
}

export function isCornisInspection(inspection?: InspectionVendorFields | null): boolean {
  if (inspection?.vendorOrganization) {
    return inspection.vendorOrganization.name?.toLowerCase() === CORNIS;
  }

  return inspection?.vendor?.name?.toLowerCase() === CORNIS;
}
